import React, { forwardRef } from "react";
import Select from "react-select";
import VirtualizedMenuList from "./VirtualizedMenuList";
import { virtualizedDropdownStyles } from "./virtualizedDropdownStyles";

const CustomOption = ({ children, ...props }) => {
  const hasActions = props.data.hasActions;

  if (hasActions) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: "8px 12px",
          cursor: "pointer",
          backgroundColor: props.isFocused ? "#333" : "transparent",
        }}
        onClick={() => props.selectOption(props.data)}
      >
        <span>{props.data.text || children}</span>
        <div
          style={{ display: "flex", gap: "8px" }}
          onClick={(e) => e.stopPropagation()}
        >
          {props.data.star}
          {props.data.edit}
          {props.data.delete}
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "8px 12px",
        cursor: "pointer",
        backgroundColor: props.isFocused ? "#333" : "transparent",
      }}
      onClick={() => props.selectOption(props.data)}
    >
      {children}
    </div>
  );
};

const VirtualizedDropdown = forwardRef(({ keepMenuOpen = false, forceClose = false, ...props }, ref) => {
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [inputValue, setInputValue] = React.useState("");
  React.useEffect(() => {
    if (forceClose) {
      setMenuOpen(false);
      setInputValue("");
    }
  }, [forceClose]);
  // keepMenuOpen: retain typed search text after selecting so users can pick
  // several matching options without retyping; clear on blur/menu close.
  const inputControlProps =
    keepMenuOpen && props.inputValue === undefined && props.onInputChange === undefined
      ? {
          inputValue,
          onInputChange: (newValue, actionMeta) => {
            if (actionMeta.action === "input-change") {
              setInputValue(newValue);
            } else if (actionMeta.action === "menu-close" || actionMeta.action === "input-blur") {
              setInputValue("");
            }
          },
        }
      : {};
  return (
    <Select
      {...props}
      {...inputControlProps}
      ref={ref}
      className="virtualized-dropdown"
      classNamePrefix="rs"
      components={{
        ...(props.components || {}),
        MenuList: VirtualizedMenuList,
        Option: CustomOption,
      }}
      maxMenuHeight={props.maxMenuHeight || 700}
      menuPortalTarget={document.body}
      isClearable={props.isClearable ?? true}
      styles={virtualizedDropdownStyles(props.width, props.menuWidth, props.radius, props.bright)}
      isMulti={props.isMulti ?? false}
      closeMenuOnSelect={keepMenuOpen ? false : props.closeMenuOnSelect}
      blurInputOnSelect={keepMenuOpen ? false : props.blurInputOnSelect}
      hideSelectedOptions={keepMenuOpen ? false : props.hideSelectedOptions}
      menuShouldScrollIntoView={false}
      menuPlacement="auto"
      menuIsOpen={menuOpen}
      onMenuOpen={() => {
        setMenuOpen(true);
        props.onMenuOpen?.();
      }}
      onMenuClose={() => {
        setMenuOpen(false);
        props.onMenuClose?.();
      }}
    />
  );
});

export default VirtualizedDropdown;
